import React from "react";
import styled from "styled-components";
import useStore from "../../stores/useStore";
import CrossIcon from "../../assets/svg/nav-cross.inline.svg";
import HamburgerIcon from "../../assets/svg/menu.inline.svg";
import MobileNav from "./MobileNav";

const NavContainer = styled.div`
  position: fixed;
  top: 0;
  right: 16px;
  z-index: 600;
  padding: 0;

  @media (${(props) => props.theme.breakpoints.md}) {
    top: 21px;
    right: 28px;
  }
`;

const DesktopInner = styled.nav`
  display: none;

  @media (${(props) => props.theme.breakpoints.md}) {
    display: flex;

    a:last-of-type {
      margin-right: 120px;
    }
  }
  align-items: center;
  flex-direction: row;
  gap: 80px;
  > :first-child {
    margin-top: 0;
  }
  > :last-child {
    margin-bottom: 0;
  }
  .link {
    margin: 0;
    width: fit-content;
    font-size: 19px;
    font-weight: 500;
    color: black;
    letter-spacing: 0.009em;
    line-height: 1.9;
  }

  .close-button {
    position: absolute;
    top: 0;
    right: 0;
    svg {
      width: 13px;
      height: 13px;
    }
  }
`;

const MobileButton = styled.button`
  pointer-events: auto;
  position: fixed;
  z-index: 200;
  top: 24px;
  right: 4px;
  display: flex;
  border: none;
  padding: 0;

  &.closed {
    svg {
      width: 25px;
      height: 17px;
    }
  }

  &.open {
    svg {
      width: 25px;
      height: 17px;
    }
  }

  @media (${(props) => props.theme.breakpoints.md}) {
    display: none;
  }
`;

const Nav = () => {
  const setShowProjectsMenu = useStore((state) => state.setShowProjectsMenu);
  const showProjectsMenu = useStore((state) => state.showProjectsMenu);
  const [showMobileNav, setShowMobileNav] = React.useState(false);

  return (
    <>
      <NavContainer className="nav">
        <DesktopInner>
          <button
            className="link"
            onClick={() => setShowProjectsMenu(!showProjectsMenu)}
          >
            Projects
          </button>
          <a className="link" href="/about">
            About
          </a>
          {showProjectsMenu && (
            <button
              className="close-button link"
              onClick={() => setShowProjectsMenu(false)}
            >
              <CrossIcon />
            </button>
          )}
        </DesktopInner>

        <MobileButton
          className={showMobileNav ? "mobile-nav open" : "mobile-nav closed"}
          onClick={() => setShowMobileNav(!showMobileNav)}
        >
          {showMobileNav ? <CrossIcon /> : <HamburgerIcon />}
        </MobileButton>
      </NavContainer>
      {showMobileNav && <MobileNav setShowMobileNav={setShowMobileNav} />}
    </>
  );
};

export default Nav;
